<template>
  <div id="automation-creation-name-and-type">
    <Input
      class="scs-input"
      heading="Automation Name"
      placeholder="Really cool automation"
      :error="errors.title"
      :initialValue="automation ? automation.title : undefined"
      @scs-input="nameInput"
    />
    <Select
      class="scs-input"
      heading="Contact Type"
      :options="contactTypes"
      :initial="automation ? automation.contactType : undefined"
      :formatter="typeFormatter"
      @input="typeInput"
    />
  </div>
</template>
<script>
import Input from "../../../../../../Components/Elements/Input.vue";
import Select from "../../../../../../Components/Elements/Select.vue";
export default {
  data() {
    return {
      contactTypes: ["client", "employee", "organizer", "vendor"],
    };
  },
  computed: {},
  methods: {
    typeInput(val) {
      this.$emit("type-input", val);
    },
    nameInput(val) {
      this.$emit("name-input", val);
    },
    typeFormatter(str) {
      return str[0].toUpperCase() + str.substring(1);
    },
  },
  created() {},
  components: {
    Input,
    Select,
  },
  emits: ["type-input", "name-input"],
  props: ["automation", "errors"],
};
</script>
<style scoped>
@media screen {
  #automation-creation-name-and-type {
    height: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .scs-input {
    width: 100%;
    margin: 20px;
  }
  @media (min-width: 800px) {
    .scs-input {
      width: 350px;
    }
  }
}
</style>
